import Vue from "vue";
import VueI18n from 'vue-i18n'
import zhCN from "./zh-CN/zh-CN"
import enUS from "./en-US/en-US"
import msMY from "./ms-MY/ms-MY"
import zhTW from "./zh-TW/zh-TW"
import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n);   // 全局注册国际化包
 
let locale =  localStorage.getItem('lang') || 'zh-CN'
// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: locale,   // 初始化
  messages: {
    "zh-CN": zhCN,
    "zh-TW": zhTW,
    "en-US": enUS,
    "ms-MY": msMY
  },
  fallbackLocale: 'zh-CN', //当前语种不存在时，默认设置当前语种为中文
}); 
ElementLocale.i18n((key, value) => i18n.t(key, value))
export default i18n